/* eslint-disable @typescript-eslint/no-unsafe-call */
import { IsString } from "@wog/mol-lib-api-contract/utils";

export enum WithdrawalReason {
	PATIENTWITHDRAWCONSENT = "PATIENTWITHDRAWCONSENT",
	OTHERS = "OTHERS",
}

export class AcpWithdrawlDTO {
	@IsString({ isOptional: false, maxLength: 250 })
	reason!: WithdrawalReason | string;
}
